import cx from 'classnames';
import React from 'react';
import { InlineSvg } from '../inline-svg';
import styles from './themed-image.module.scss';
/**
 * Renders an image that follows the app theme, in one of three modes:
 *
 * - `inline`: fetches a tokenized SVG and inlines it, so its colors resolve
 *   against the active theme (light/dark/brand).
 * - `srcDark`: renders a light/dark pair and CSS shows the one matching
 *   `data-theme` on `<html>` — the app's own theme (user preference / embed
 *   host), not the OS `prefers-color-scheme`. Both load eagerly so a theme
 *   switch never shows a blank and headless captures always have the image.
 *   Static pairs do not pick up a brand color.
 * - neither: a plain image.
 */
export const ThemedImage = ({ src, srcDark, inline, alt = '', className, 'data-testid': dataTestId, }) => {
    if (inline) {
        // Inlined markup has no alt; label or hide it on the wrapper instead.
        const a11yProps = alt
            ? { role: 'img', 'aria-label': alt }
            : { 'aria-hidden': true };
        return (React.createElement("span", { className: cx(styles.themedImage, styles.inline, className), "data-testid": dataTestId, ...a11yProps },
            React.createElement(InlineSvg, { path: src })));
    }
    // The caller's class goes on each <img> so it sizes them exactly as it
    // would a plain <img>; the wrapper itself stays out of layout.
    return (React.createElement("span", { className: styles.images, "data-testid": dataTestId },
        React.createElement("img", { src: src, alt: alt, className: cx(className, { [styles.light]: !!srcDark }) }),
        srcDark && (React.createElement("img", { src: srcDark, alt: alt, className: cx(className, styles.dark) }))));
};
//# sourceMappingURL=themed-image.js.map